export default "__VITE_ASSET__DmRgcyDC__"